'use client';

import type { OverlayTriggerState } from '@react-stately/overlays';
import { useAuth } from 'react-oidc-context';
import styled from 'styled-components';

import { Sheet } from '@zoomit/mobile-sheet';
import { Box, Modal } from '@zoomit/primitives';
import { UnauthorizedModal, isMobile } from '@zoomit/web-kit';
import { ModalHead, Typography, theme } from '@zoomit/zoomit-ds';

import ProblemReportContent from '../single/ProblemReportContent';

type Props = {
  productTitle: string;
  productId: string;
  problemReportPopupState: OverlayTriggerState;
};

const ProblemReportPopup = (props: Props) => {
  const { productTitle, productId, problemReportPopupState } = props;

  const { isAuthenticated } = useAuth();

  if (!problemReportPopupState.isOpen) {
    return null;
  }

  if (!isAuthenticated) {
    return (
      <UnauthorizedModal isOpen={problemReportPopupState.isOpen} onClose={problemReportPopupState.close} />
    );
  }

  return isMobile ? (
    <Sheet isOpen={problemReportPopupState.isOpen} onClose={problemReportPopupState.close}>
      <Sheet.Container>
        <Sheet.Header>
          <Box spacing={{ pt: 'x10', px: 'x11', pb: 'x' }}>
            <Title>
              <Typography className="fa" variant="h5">
                گزارش مشکل در {productTitle}
              </Typography>
            </Title>
          </Box>
        </Sheet.Header>
        <Sheet.Content>
          <ProblemReportContent productId={productId} onClose={problemReportPopupState.close} />
        </Sheet.Content>
      </Sheet.Container>
      <Sheet.Backdrop />
    </Sheet>
  ) : (
    <Modal size="md" isOpen={problemReportPopupState.isOpen} onClose={problemReportPopupState.close}>
      <ModalHead title={`گزارش مشکل در ${productTitle}`} onClose={problemReportPopupState.close} />
      <ProblemReportContent productId={productId} onClose={problemReportPopupState.close} />
    </Modal>
  );
};

export default ProblemReportPopup;

const Title = styled.div`
  position: relative;
  margin-right: 1.6rem;

  &::before {
    content: '';
    position: absolute;
    width: 4px;
    height: 100%;
    top: 0;
    right: -1.6rem;
    background-color: var(${theme.primary1});
  }
`;
